import { AdhocHoldOfCntrSearchCriteria } from "domain/entity/AdhocHoldOfContainer/AdhocHoldOfCntrSearchCriteria";
import { AdhocHoldOfCntrConstant } from "presentation/constant/AdhocHoldOfContainer/AdhocHoldOfCntrConstant";
import { useAdhocHoldOfCntrVM } from "presentation/hook/AdhocHoldOfContainer/useAdhocHoldOfCntrVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useAdhocHoldOfCntrTracked } from "presentation/store/AdhocHoldOfContainer/AdhocHoldOfCntrProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, HPHInputMask, HPHInputTextarea, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const AdhocHoldOfCntrSearchPanel = () => {
    const SCREEN_CONSTANT = AdhocHoldOfCntrConstant;
    const [adhocHoldOfCntrState] = useAdhocHoldOfCntrTracked();
    const adhocHoldOfCntrVM = useAdhocHoldOfCntrVM();
    const { searchCriteria } = adhocHoldOfCntrState;
    const [isLoading, setIsLoading] = useState(false);
    const messageBarVM = useMessageBarVM();

    const resetButtonClicked = useCallback(() => {
        adhocHoldOfCntrVM.onSearchCriteriaResetClick();
    }, [adhocHoldOfCntrVM]);

    const searchButtonClicked = useCallback((searchCriteria: AdhocHoldOfCntrSearchCriteria) => {
        if (!searchCriteria.consortiumCode ||
            !searchCriteria.vesselCode ||
            !searchCriteria.voyageCode
        ) {
            let errorCode1: string = `${SCREEN_CONSTANT.CONSORTIUM_CODE},
                                     ${SCREEN_CONSTANT.VESSEL_CODE} and 
                                     ${SCREEN_CONSTANT.VOYAGE_CODE}`;
            let errorCode2: string = " are mandatory criteria.";
            messageBarVM.showError(errorCode1 + errorCode2);
            return;
        }

        if ((!searchCriteria.cntrNoList?.length || (searchCriteria.cntrNoList?.length === 1 && searchCriteria.cntrNoList[0] === '')) &&
            !searchCriteria.billOfLading &&
            !searchCriteria.shippingBill) {
            let errorCode1: string = `Either ${SCREEN_CONSTANT.CONTAINER_NO},
                                      ${SCREEN_CONSTANT.BILL_OF_LADING} or 
                                      ${SCREEN_CONSTANT.SHIPPING_BILL} should be inputted.`;
            messageBarVM.showError(errorCode1);
            return;
        }

        setIsLoading(true);
        adhocHoldOfCntrVM.setIsSearchLoading(true);
        adhocHoldOfCntrVM.onSearch(searchCriteria).then((data) => {
            setIsLoading(false);
            adhocHoldOfCntrVM.setIsSearchLoading(false);
        }).catch(error => {
            setIsLoading(false);
            adhocHoldOfCntrVM.setIsSearchLoading(false);
        })

    }, [SCREEN_CONSTANT.BILL_OF_LADING, SCREEN_CONSTANT.CONSORTIUM_CODE, SCREEN_CONSTANT.CONTAINER_NO, SCREEN_CONSTANT.SHIPPING_BILL, SCREEN_CONSTANT.VESSEL_CODE, SCREEN_CONSTANT.VOYAGE_CODE, adhocHoldOfCntrVM, messageBarVM])

    // const memoConsortiumCode = useMemo(() =>
    //     <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
    //         <NbisCommonField
    //             errorMessages={{}}
    //             isReadOnly={false}
    //             isShowOptional={false}
    //             readOnlyValue={searchCriteria?.consortiumCode || ''}
    //             fieldValue={searchCriteria?.consortiumCode}
    //             fieldLabel={SCREEN_CONSTANT.CONSORTIUM_CODE}
    //             isSaveClicked={false}
    //             fieldType={FieldType.DROPDOWN}
    //             fieldKey={'consortiumCode'}
    //             maxLength={60}
    //             sort={false}
    //             options={adhocHoldOfCntrState.dynamicOptions.consortiumCodeDropdownOptions}
    //             requiredFieldList={[]}
    //             onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
    //                 adhocHoldOfCntrVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
    //     </div>
    //     , [searchCriteria?.consortiumCode, SCREEN_CONSTANT.CONSORTIUM_CODE, adhocHoldOfCntrState.dynamicOptions.consortiumCodeDropdownOptions, adhocHoldOfCntrVM])

    // const memoVesselCode = useMemo(() =>
    //     <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "20px" }}>
    //         <NbisCommonField
    //             errorMessages={{}}
    //             isReadOnly={false}
    //             isShowOptional={false}
    //             readOnlyValue={searchCriteria?.vesselCode ?? ''}
    //             fieldValue={searchCriteria?.vesselCode}
    //             fieldLabel={SCREEN_CONSTANT.VESSEL_CODE}
    //             isSaveClicked={false}
    //             fieldType={FieldType.TEXT}
    //             fieldKey={'vesselCode'}
    //             maxLength={6}
    //             isTextFieldCapitalize={true}
    //             requiredFieldList={[]}
    //             onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
    //                 adhocHoldOfCntrVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
    //     </div>
    //     , [SCREEN_CONSTANT.VESSEL_CODE, adhocHoldOfCntrVM, searchCriteria?.vesselCode])

    // const memoVoyageCode = useMemo(() =>
    //     <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "20px" }}>
    //         <NbisCommonField
    //             errorMessages={{}}
    //             isReadOnly={false}
    //             isShowOptional={false}
    //             readOnlyValue={searchCriteria?.voyageCode ?? ''}
    //             fieldValue={searchCriteria?.voyageCode}
    //             fieldLabel={SCREEN_CONSTANT.VOYAGE_CODE}
    //             isSaveClicked={false}
    //             fieldType={FieldType.TEXT}
    //             fieldKey={'voyageCode'}
    //             maxLength={10}
    //             isTextFieldCapitalize={true}
    //             requiredFieldList={[]}
    //             onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
    //                 adhocHoldOfCntrVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
    //     </div>
    //     , [SCREEN_CONSTANT.VOYAGE_CODE, adhocHoldOfCntrVM, searchCriteria?.voyageCode])

    const memoCntrNo = useMemo(() =>
        <div className='im-flex-row-item'>
            <HPHInputTextarea
                label={SCREEN_CONSTANT.CONTAINER_NO}
                width="470px"
                rows={3}
                resizable={false}
                helpIcon={true}
                toolTipText={"Use comma ( , ) as delimiter"}
                value={searchCriteria.cntrNoList?.join(",")}
                onChange={(e) => { adhocHoldOfCntrVM.onTextAreaChange(e, "cntrNoList", true) }} />
        </div>
        , [SCREEN_CONSTANT.CONTAINER_NO, searchCriteria.cntrNoList, adhocHoldOfCntrVM])

    const memoBillOfLading = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.billOfLading ?? ''}
                fieldValue={searchCriteria?.billOfLading}
                fieldLabel={SCREEN_CONSTANT.BILL_OF_LADING}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'billOfLading'}
                maxLength={35}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    adhocHoldOfCntrVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.BILL_OF_LADING, adhocHoldOfCntrVM, searchCriteria?.billOfLading])

    const memoShippingBill = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "20px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.shippingBill ?? ''}
                fieldValue={searchCriteria?.shippingBill}
                fieldLabel={SCREEN_CONSTANT.SHIPPING_BILL}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'shippingBill'}
                maxLength={35}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    adhocHoldOfCntrVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SHIPPING_BILL, adhocHoldOfCntrVM, searchCriteria?.shippingBill])

    const memoCoVslVoy = useMemo(() =>
        <div className='flex-row-item'>
            <HPHInputMask
                width='470px'
                label={SCREEN_CONSTANT.CO_VSL_VOY}
                value={{
                    co: searchCriteria.consortiumCode ?? '',
                    vsl: searchCriteria.vesselCode ?? '',
                    voy: searchCriteria.voyageCode ?? ''
                }}
                fieldConfiguration={{
                    co: { maxLength: 4, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                    vsl: { maxLength: 6, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                    voy: { maxLength: 10, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                }}
                onDataChange={(e: any) => adhocHoldOfCntrVM.onSearchCoVslVoyChange(e, {
                    co: 'consortiumCode',
                    vsl: 'vesselCode',
                    voy: 'voyageCode'
                })} />
        </div>
        , [SCREEN_CONSTANT.CO_VSL_VOY, searchCriteria.consortiumCode, searchCriteria.vesselCode, searchCriteria.voyageCode, adhocHoldOfCntrVM])

    return (
        <div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{SCREEN_CONSTANT.SEARCH_CRITERIA}</SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={adhocHoldOfCntrVM.onSearchClick} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>

                        {/* <CriteriaItemContainer> */}
                        {/* {memoConsortiumCode}
                            {memoVesselCode} */}
                        {/* </CriteriaItemContainer> */}

                        <CriteriaItemContainer>
                            {/* {memoVoyageCode} */}
                            {memoCoVslVoy}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoCntrNo}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoBillOfLading}
                            {memoShippingBill}
                        </CriteriaItemContainer>

                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={'Reset'} size={'Small'} theme={'Secondary'} onClick={resetButtonClicked} />
                <HPHButton label={'Search'} size={'Small'} theme={'Primary'} onClick={() => searchButtonClicked(searchCriteria)} />
            </SidebarActionBar>
        </div>
    );
}

export default AdhocHoldOfCntrSearchPanel;
